// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"74d844a4","202":"9b27adf6","233":"148a7650","305":"1005bfa9","367":"8f0cfd49","420":"f3a27dde","458":"521f84d7","492":"e5986bf4","558":"0fb67ec4","629":"dfc83fc7","756":"121497f5","807":"e4e4f54a","821":"1147cda7","972":"886d5551"}[chunkId] + ".chunk.js";
};